import { MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { waHref } from "@/lib/wa";

export default function CtaBanner({ content }) {
  const cta = waHref(content);
  return (
    <section className="px-4 pb-24 sm:px-6" data-testid="cta-banner">
      <Reveal className="mx-auto max-w-7xl">
        <div className="bg-dots-light relative overflow-hidden rounded-3xl bg-brand px-8 py-16 text-center sm:px-12 sm:py-20">
          <div
            className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-white/10"
            aria-hidden="true"
          />
          <div
            className="pointer-events-none absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-white/10"
            aria-hidden="true"
          />
          <h2 className="relative font-display text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl">
            Sudah Siap Memiliki Rumah Baru di Pontianak?
          </h2>
          <p className="relative mx-auto mt-4 max-w-2xl text-base leading-relaxed text-white/85">
            Hubungi tim marketing PT. CAHAYA SAKOFA MULIA untuk mendapatkan informasi unit, harga, dan ketersediaan terbaru.
          </p>
          <a
            href={cta}
            target={cta.startsWith("http") ? "_blank" : undefined}
            rel="noopener"
            data-testid="cta-banner-whatsapp"
            className="relative mt-9 inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 text-sm font-bold text-brand transition-transform duration-200 hover:scale-[1.03] active:scale-95"
          >
            <MessageCircle className="h-5 w-5" />
            Hubungi Marketing via WhatsApp
          </a>
        </div>
      </Reveal>
    </section>
  );
}
